import { Backdrop, Stack, Typography } from '@mui/material';
import { useSelector } from "react-redux";
import DepartmentPicker from './DepartmentPicker';

export default function DepartmentPickerPage() {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    return (
        <Backdrop open sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, height: 1 }}>
            <Stack sx={{ width: { xs: '90%', md: '50%' } }}>
                <Typography sx={{ textAlign: 'center', typography: { xs: 'h5', md: 'h3' }, zIndex: (theme) => theme.zIndex.drawer + 2, color: 'primary.light' }}>{resourceFinal[appLanguage].messages.DEPARTMENT_PICKER}</Typography>
                <Typography variant="subtitle1" sx={{ textAlign: 'center', zIndex: (theme) => theme.zIndex.drawer + 2, color: 'primary.light', mb: 4 }} gutterBottom>{resourceFinal[appLanguage].messages.DEPARTMENT_PICKER_INTRO}</Typography>
                <DepartmentPicker compact={false} />
            </Stack>
        </Backdrop>
    );
}
